module.exports = __webpack_public_path__ + "static/media/22.e8036fdd.jpg";